<div class="login-layout">
  <div class="login-layout__content">
    <div class="logo-login">
        <app-logo logoType="name"></app-logo>
    </div>
    <ng-content></ng-content>
    
  </div>
  <div class="login-layout__image">
    <picture>
      <source media="(max-width: 767px)" srcset="/assets/images/mobile-login.svg">
      <source media="(max-width: 900px)" srcset="/assets/images/768.svg">
      <source media="(max-width: 1279px)" srcset="/assets/images/1279.svg">
      <img src="/assets/images/login/bg.svg" class="bg-image" alt="Login Image" />
    </picture>
     <img src="/assets/images/login/dashboard.svg" class="dashboard-image" alt="Login Image" />
     <img src="/assets/images/login/logo-list.svg" class="dashboard-image-mobile" alt="Login Image" />
  </div>
  <div class="footer-links">
    <a href="https://www.way.com/aboutUs/privacyPolicy" target="_blank" class="btn btn-tertiary btn-small">Privacy Policy</a>
    <a href="https://www.way.com/aboutUs/userAgreement" target="_blank" class="btn btn-tertiary btn-small">Terms and Conditions</a>
  </div>
</div>
